// extracted by mini-css-extract-plugin
export default {"container":"NE-z","dimension":"OE-z","dimensionLabels":"PE-z"};